import React, { useEffect, useState } from 'react';
import { FiRotateCcw } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { fetchSocialColors } from '../../actions/socialPicturesActions';
import { getChangeableColors, COLOR_SLOT_LABELS } from '../../utilities/infographics';
import '../../styles/infographics.css';

// Цвета самой картинки (не команд). В приложении это отдельный экран ColorsChoose
// с колесом цвета: он подменяет базовые цвета шаблона в HTML локально, а на сервер
// уходит массив activeColors.
// На сайте проще и точнее: меняем цвет — сразу перезапрашиваем превью у сервера,
// поэтому локальная подмена строк в HTML не нужна.

export default function ColorsControl({ value, setValue, pattern }) {
    const dispatch = useDispatch();
    const defaults = getChangeableColors(pattern.id);
    const [favColors, setFavColors] = useState([]);

    const current = Array.isArray(value.activeColors) && value.activeColors.length
        ? value.activeColors
        : defaults;

    // Палитра клиента — быстрые пресеты рядом с пипеткой
    useEffect(() => {
        let cancelled = false;
        dispatch(fetchSocialColors())
            .then(data => {
                if (cancelled) return;
                const rows = Array.isArray(data) ? data : (data && data.data) || [];
                setFavColors(rows.map(row => row.hex).filter(Boolean));
            })
            .catch(e => {
                if (!cancelled) console.error('Ошибка загрузки палитры:', e);
            });
        return () => { cancelled = true; };
    }, [dispatch]);

    const change = (index, color) => {
        const next = current.slice();
        next[index] = color;
        setValue('activeColors', next);
    };

    const reset = () => setValue('activeColors', false);

    // input[type=color] не понимает именованные цвета вроде "white"
    const asHex = (color) => {
        if (!color) return '#ffffff';
        if (color.charAt(0) === '#') return color;
        if (color === 'white') return '#ffffff';
        if (color === 'black') return '#000000';
        return '#ffffff';
    };

    return (
        <div className="igControl">
            <div className="igControlHead">
                <span className="igControlLabel">Цвета картинки</span>
                <span className="igControlHint">
                    Перекрашивает оформление шаблона, не логотипы команд
                </span>
            </div>

            {defaults.map((_, index) => (
                <div className="igColorSlot" key={index}>
                    <span className="igColorSlotLabel">
                        {COLOR_SLOT_LABELS[index] || `Цвет ${index + 1}`}
                    </span>
                    <div className="igColorSlotControls">
                        <input
                            type="color"
                            className="igColorInput"
                            value={asHex(current[index])}
                            onChange={(e) => change(index, e.target.value)}
                        />
                        {favColors.length > 0 && (
                            <div className="igColorPresets">
                                {favColors.map(color => (
                                    <button
                                        type="button"
                                        key={color}
                                        aria-label={color}
                                        className={`igSwatch igSwatchSmall ${
                                            asHex(current[index]).toLowerCase() === color.toLowerCase()
                                                ? 'igSwatchActive' : ''
                                        }`}
                                        style={{ background: color }}
                                        onClick={() => change(index, color)}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            ))}

            {Array.isArray(value.activeColors) && (
                <button type="button" className="igLinkBtn" onClick={reset}>
                    <FiRotateCcw /> Вернуть цвета шаблона
                </button>
            )}
        </div>
    );
}
